<template>
  <div class="error_container" :class="imgSrc.includes('cont') ? 'error_cont' : ''" :style="{ ...selfStyle }">
    <img :src="imgSrc" alt="" class="img" :class="imgSrc.includes('cont') ? 'img_cont' : ''" />
    <span>{{ info }}</span>
    <button v-if="showRetry" class="retry_btn" @click="emit('retry')">{{ retryText }}</button>
  </div>
</template>
<script setup lang="ts">
import { ref, watch, getCurrentInstance } from 'vue'
interface IProps {
  status?: {
    info?: String
    imgSrc?: String
    showRetry?: Boolean
    retryText?: String
  }
  selfStyle?: Object
}
const props = withDefaults(defineProps<IProps>(), {
  status: () => {
    return {
      info: '',
      imgSrc: '',
      showRetry: false,
      retryText: ''
    }
  },
  selfStyle: () => {
    return {}
  }
})
const emit = defineEmits<{
  (e: 'retry'): void
}>()
const proxy = getCurrentInstance()?.appContext.config.globalProperties
const info = ref<String>(props.status?.info || proxy?.$t('app_empty') || '')
const imgSrc = ref(
  props.status.imgSrc
    ? require('@/assets/images/empty/' + props.status?.imgSrc)
    : require('@/assets/images/empty/empty.png')
)
const showRetry = ref<Boolean>(props.status?.showRetry || false)
const retryText = ref<String>(props.status?.retryText || '重试')
watch(
  () => props.status,
  (newValue) => {
    info.value = newValue.info || proxy?.$t('app_empty') || ''
    imgSrc.value = newValue.imgSrc
      ? require('@/assets/images/empty/' + newValue.imgSrc)
      : require('@/assets/images/empty/empty.png')
    showRetry.value = newValue.showRetry || false
    retryText.value = newValue.retryText || '重试'
  },
  { deep: true }
)
</script>

<style scoped lang="less">
.error_container {
  width: calc(100vw);
  height: calc(100vh - 200px);
  background-color: #f4f5f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  span {
    font-size: 14px;
    color: #999999;
    line-height: 20px;
    display: block;
    margin-top: 8px;
    text-align: center;
  }
  .img {
    width: 178px;
    height: 178px;
  }
  .img_cont {
    width: 115px;
    height: 115px;
  }
  .retry_btn {
    margin-top: 16px;
    padding: 4px 18px;
    border-radius: 16px;
    border: 1px solid #c9c9c9;
    background: #ffffff;
    color: #1a1a1a;
    font-size: 14px;
  }
}
.error_cont {
  width: 100%;
  height: unset;
  background-color: transparent;
}
</style>
